// The "you have unsaved changes" warning that fires when the tab is closed mid-save.
//
// Admin forms marked `data-behavior="submit-on-change"` save as you click, with no Save button to
// tell you the write landed — so closing the tab a moment later can genuinely lose an edit, and
// global_behaviors' `beforeunload` handler warns about it.
//
// Deciding whether a save is still in flight is the whole difficulty. jQuery's `$.active` cannot
// answer it on its own: it is decremented in the *complete* phase, AFTER success callbacks have
// run, so code that navigates from inside an AJAX response handler still counts its own finished
// request. That is not a rare shape here — AjaxHelper's `redirect`/`reload` directives are exactly
// that. So `$.active > 0` is true for every app-initiated navigation, and the window below is the
// only thing keeping the warning off them: it fires whenever the app redirects within
// SAVE_WINDOW_MS of a save, which is precisely what a user doing anything quickly will do.
//
// Hence suppressUnloadWarning(): the app says "this navigation is mine", and the warning stands
// down.
const SAVE_WINDOW_MS = 15_000

// When the current save window lapses; 0 when nothing can still be in flight. A deadline rather
// than a flag flipped by a timer: nothing needs to observe the moment it passes, only whether it
// has — and a backgrounded tab throttles timers hard enough that a 15-second one would keep the
// warning armed long after the window it is meant to represent had closed.
let saveWindowEndsAt = 0

// A submit-on-change form just posted. Treat a save as possibly in flight until the window lapses.
export const saveTriggered = () => {
  saveWindowEndsAt = Date.now() + SAVE_WINDOW_MS
}

// The app is navigating on purpose — an AJAX response asked for a redirect or a reload. The
// request carrying that answer succeeded, so warning about it would be warning about ourselves.
//
// This does drop the warning for a *different* save racing that navigation. Deliberate: the window
// is a coarse 15-second guess rather than a real in-flight signal, so almost every navigation it
// suppresses had nothing outstanding at all — and prompting all of them to catch the rare race is
// what made the dialog a nuisance to begin with.
export const suppressUnloadWarning = () => {
  saveWindowEndsAt = 0
}

export const saveMayBeInFlight = () => Date.now() < saveWindowEndsAt
